import { trackRemoveCartLine } from "@DSG/Common/DSGTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, DispatchBeginRemoveCartLine } from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
addToChainAfter(chain, DispatchBeginRemoveCartLine, removeCartLineTracking);

// get the type of props using this
type TrackingParameters = Parameters<typeof DispatchBeginRemoveCartLine>[0];

function removeCartLineTracking(props: TrackingParameters) {
    const state = props.getState();
    const cartState = getCurrentCartState(state);

    const cartlines = cartState?.value?.cartLines;
    const cartLine = cartlines?.find(x => x.id === props.parameter.cartLineId);

    //    const cartLine = props.apiResult;
    if (cartLine) {
        trackRemoveCartLine(cartLine, state);
    }
}
